import cn from "classnames";

import styles from "./TableWrapper.module.scss";
import Paginate from "../../Paginate";

import BulkActions from "../BulkActions";

import { TableWrapperProps } from "../Table.props";

/**
 * @deprecated
 */
function TableWrapper<T>(props: TableWrapperProps<T>): JSX.Element | null {
  const {
    children,
    resultsTotalCount,
    queryOptions,
    bulkActions,
    handleUpdateRequest,
    paginate,
    testId,
    handleBulkActionsApply,
    resetTable,
    paginatePosition,
    resultsMoreFlag,
  } = props;

  const showBulkActions = Object.keys(bulkActions || {}).length;
  const sectionClass = cn(
    { [styles["paginateUI"]]: !showBulkActions },
    { [styles["paginateUI-BulkActions"]]: showBulkActions },
    { [styles["table-wrapper-top"]]: showBulkActions || paginate },
  );

  const PaginateComponent = (): JSX.Element | null => {
    if (paginate && handleUpdateRequest !== undefined && queryOptions !== undefined && resultsTotalCount !== undefined) {
      return (
        <Paginate
          handleUpdateRequest={(option) => {
            handleUpdateRequest(option);
            resetTable();
          }}
          queryOptions={queryOptions}
          resultsTotalCount={resultsTotalCount}
          displayDescription={true}
          testId={testId}
          resultsMoreFlag={resultsMoreFlag}
        />
      );
    }

    return null;
  };

  const BulkComponent = (): JSX.Element | null => {
    if (handleBulkActionsApply !== undefined && bulkActions !== undefined) {
      return <BulkActions paginate={paginate ? true : false} bulkActions={bulkActions} handleBulkActionsApply={handleBulkActionsApply} />;
    }

    return null;
  };

  return (
    <div className={styles["table-wrapper"]} data-testid={testId ? `test__topBar-${testId}` : undefined}>
      <div className={sectionClass}>
        <BulkComponent />
        {(paginatePosition == "top" || paginatePosition == "all") && <PaginateComponent />}
      </div>
      <div
        className={`data-table-wrapper-body ${styles["table-wrapper-body"]}`}
        data-testid={testId ? `test__tableBodyWrapper-${testId}` : undefined}
      >
        {children}
      </div>
      <div className={styles["table-wrapper-bottom"]} data-testid={`test__paginateTop-${testId}`}>
        {(paginatePosition == "bottom" || paginatePosition == "all") && <PaginateComponent />}
      </div>
    </div>
  );
}

/**
 * @deprecated
 */
export default TableWrapper;
